import React, { createRef, ReactNode } from "react";
import { IBaseComponentProps, NSRouterMakerProps, NSBoxString } from 'namirasoft-site-react';
import { NSSection, NSSpace, NSSpaceSizeType, NSButtonBlue } from 'namirasoft-site-react';
import { NSARouterMakerProps } from '../NSARouterMakerProps';
import Styles from './NSAVerificationPage.module.css';
import { BaseServer } from "namirasoft-core";

export interface NSAVerificationPageProps extends IBaseComponentProps, NSRouterMakerProps, NSARouterMakerProps
{
	contact_type: string;
	contact_value_name: string;
	getContactValue: (checkErrors: boolean) => string;
	onRequest: (address: string) => Promise<void>;
	onVerify: (code: string) => Promise<void>;
	onFinished: () => void;
	children?: ReactNode;
}

export interface NSAVerificationPageState
{
	isSendCode: boolean;
}

export class NSAVerificationPage extends React.Component<NSAVerificationPageProps, NSAVerificationPageState>
{
	private NSButtonBlue_Verify = createRef<NSButtonBlue>();
	private NSBoxString_Code = createRef<NSBoxString>();
	constructor(props: NSAVerificationPageProps)
	{
		super(props);
		this.state = { isSendCode: false };
		this.onRequest = this.onRequest.bind(this);
		this.onVerify = this.onVerify.bind(this);
	}
	private async onRequest(onFinshied: () => void)
	{
		try
		{
			this.props.onRequest(this.props.getContactValue(true)).then(() =>
			{
				this.setState({ isSendCode: true });
				this.props.notifier.onSuccess(`Verification code has been sent successfully.`);
				onFinshied();
			}).catch(onFinshied);
		} catch (error)
		{
			this.props.notifier.onError(error as Error);
			onFinshied();
		}
	}
	private async onVerify(onFinshied: () => void)
	{
		try
		{
			let code = this.NSBoxString_Code.current?.getValue() ?? "";
			this.props.onVerify(code).then(() =>
			{
				this.props.notifier.onSuccess("Verification has been done successfully.");
				this.props.notifier.onSuccess("Redirecting ...", 2000);
				setTimeout(() =>
				{
					this.props.onFinished();
					onFinshied();
				}, 2000);
			}).catch(e =>
			{
				onFinshied();
				if (BaseServer.isErrorCode(e, 410) || BaseServer.isErrorCode(e, 404))
					this.setState({ isSendCode: false });
			});
		} catch (error)
		{
			this.props.notifier.onError(error as Error);
			onFinshied();
		}
	}
	override componentDidMount(): void
	{
		let code = this.props.url.getQuery("code") ?? "";
		if (code)
		{
			this.setState({ isSendCode: true }, () =>
			{
				this.NSBoxString_Code.current?.setValue(code, () =>
				{
					this.NSButtonBlue_Verify.current?.performClick();
				});
			});
		}
	}
	override render()
	{
		return (
			<>
				<NSSection>
					<div
						className={`${Styles.nsa_verification_container} ${this.props.classList?.join(" ") ?? ""}`}
						style={this.props.style}
					>
						<img
							src={"https://static.namirasoft.com/image/concept/verification/purple.png"}
							alt={'verification vector'}
							className={Styles.nsa_verification_vector}
						/>
						<div className='m-0'>
							<p className='m-2'>Type: {this.props.contact_type}</p>
							{
								((this.state.isSendCode || !this.props.children) && this.props.getContactValue(false)) &&
								<p className='m-2'>{this.props.contact_value_name}: {this.props.getContactValue(false)}</p>
							}
							{
								this.props.children &&
								<div style={{ display: this.state.isSendCode ? "none" : undefined }}>
									{this.props.children}
								</div>
							}
						</div>
						{
							this.state.isSendCode ?
								<>
									<p
										style={{ margin: "0px" }}
									>Please enter the code you received</p>
									<NSBoxString
										ref={this.NSBoxString_Code}
										title='Verification Code'
										placeholder='Enter the code'
										hideHeader={true}
										required={true}
										min_length={6}
										max_length={6}
										input={{ style: { fontSize: '24px', fontWeight: "bold", textAlign: "center" } }}
									/>
								</> :
								<>
									<NSButtonBlue
										title='Send Code'
										onClick={{
											action: (onFinished) =>
											{
												this.onRequest(onFinished);
											},
										}}
									/>
								</>
						}
					</div>
					<NSSpace size={NSSpaceSizeType.NORMAL}></NSSpace>
					{
						this.state.isSendCode &&
						<>
							<NSButtonBlue
								ref={this.NSButtonBlue_Verify}
								title="Verify"
								onClick={{
									action: (onFinished) =>
									{
										this.onVerify(onFinished);
									},
								}}
							/>
							<NSSpace size={NSSpaceSizeType.SMALL}></NSSpace>
							<button onClick={() =>
							{
								this.setState(prev => ({ ...prev, isSendCode: false }))
							}} className={Styles.nsa_resend_button}>Resend Code</button>
						</>
					}
				</NSSection>
			</>
		);
	}
}